import * as requestFromServer from "./servicesApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";

// services -> get services api
export const getServicesAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true)
    const response = await requestFromServer.getServices(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICES_LIST, {services:response}))
      setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// services -> create services api
export const createServiceAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createService(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      navigate(baseRouteMaker(routes.SERVICES));
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// services -> update services api
export const updateServiceAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateService(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      navigate(baseRouteMaker(routes.SERVICES));
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// services -> get service by id api
export const getServiceByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceById(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICE_BY_ID,{service:response}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// services -> delete service by id api
export const deleteServiceByIdAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.deleteServiceById(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};


// services -> get services select list api
export const getServicesSelectListAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServicesSelectList(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICES_SELECT_LIST, {servicesSelectList:response?.data}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};